import {memo, useContext, useState} from 'react'

import type {BuildTypeId, ChangeId} from '../../../../../types'
import {getChangeExtensionsPath} from '../../../../common/InjectExtensions/InjectExtensions.utils'
import SequenceLoader from '../../../../common/SequenceLoader/SequenceLoader'
import {ChangeContext, ChangeView} from '../../Change/Change.context'
import ChangeFiles from '../../ChangeFiles/ChangeFiles'
import {getChange} from '../../Changes.selectors'

import ActionButtons from './ActionButtons/ActionButtons'
import ChangeBuildTypeSelect from './ChangeBuildTypeSelect/ChangeBuildTypeSelect'

import styles from './FilesTab.css'

import {useAppSelector} from 'src/hooks/react-redux'

type Props = {
  changeId: ChangeId
  buildTypeId: BuildTypeId | undefined | null
}

function FilesTab({changeId, buildTypeId}: Props) {
  const [selectedBuildTypeId, setSelectedBuildTypeId] = useState(buildTypeId)
  const {personal} = useAppSelector(state => getChange(state, changeId)) ?? {}
  const {changeView} = useContext(ChangeContext)
  return (
    <div>
      <SequenceLoader>
        {changeView !== ChangeView.OVERALL && (
          <ChangeBuildTypeSelect
            seqKey="ChangeBuildTypeSelect"
            className={styles.action}
            buildTypeId={selectedBuildTypeId}
            onChangeBuildTypeId={setSelectedBuildTypeId}
            changeId={changeId}
          />
        )}
        {changeView !== ChangeView.OVERALL && (
          <ActionButtons
            seqKey="ActionButtons"
            className={styles.action}
            entityHref={getChangeExtensionsPath({
              buildTypeId: selectedBuildTypeId,
              changeId,
              personal,
            })}
          />
        )}
        <ChangeFiles
          seqKey="ChangeFiles"
          changeId={changeId}
          buildTypeId={selectedBuildTypeId}
          withHeading={false}
        />
      </SequenceLoader>
    </div>
  )
}

export default memo<Props>(FilesTab)
